import { render, staticRenderFns } from "./kxj-watermark.vue?vue&type=template&id=45264d02&"
import script from "./kxj-watermark.vue?vue&type=script&lang=js&"
export * from "./kxj-watermark.vue?vue&type=script&lang=js&"
import style0 from "./kxj-watermark.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.9.7@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports